import store from './store/index.js'
import { createRouter, createWebHistory } from "vue-router";

import HomePage from "./components/pages/HomePage";
// import aboutPage from "./components/pages/HelloWorld";
import memberRegistration from "./components/pages/memberRegistration";
import registrationSearch from "./components/pages/NewMembersearch"; 
import memberSearch from "./components/pages/memberSearch";
import allMembers from "./components/pages/allMembers";
import receivePayments from "./components/pages/receivePayments"; 
// import allPayments from "./components/pages/allPayments"; 
import allPayments from "./components/pages/allPayments.vue"; 

import createMember from "./components/pages/newMembers";
import mpesaPayments from "./components/pages/mpesaPayments.vue";
import registerExpense from "./components/pages/registerExpense.vue";
import allExpenses from "./components/pages/allExpenses.vue";
import memberPayments from "./components/pages/memberPayments.vue";
import twiga from "./components/pages/twiga.vue";
import paidMembers from "./components/pages/paidMembers.vue";





import Login from "./components/pages/Login";

//sammy links














const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/", component: HomePage },
    // { path: "/about", component: aboutPage },
    { path: "/member/registration", component: registrationSearch },
    { path: "/twiga", component: twiga },
     { path: "/paid/members", component: paidMembers },

    { path: "/member/registration/:memberid", component: memberRegistration },
    { path: "/member/search", component: memberSearch },
    { path: "/all/members", component: allMembers, meta: {
      requiresAuth: true
    } },
    { path: "/mpesa/payments/:memberId", component: memberPayments, meta: {
      requiresAuth: true
    } },
    { path: "/receive/payments", component: receivePayments, meta: {
      requiresAuth: true
    } },
    { path: "/all/payments", component: allPayments, meta: {
      requiresAuth: false
    } },
  
  
    { path: "/create/member", component: createMember, meta: {
      requiresAuth: true
    } },
    { path: "/register/expense", component: registerExpense, meta: {
      requiresAuth: true
    } },
    { path: "/all/expenses", component: allExpenses, meta: {
      requiresAuth: true
    } },
    { path: "/login/", component: Login },

    // {path: "/dashboard", component:DashBoard, meta: {
    //   requiresAuth: true
    // }},



    { path: "/mpesa/payments", component: mpesaPayments, meta: {
      requiresAuth: true
    } },

   

    
   
    

  ],
});
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
   
    if (!store.getters.isLoggedIn) {
      next({ path: '/' })
    } else {
      next() 
    }
  } else {
    next() 
  }
})

export default router;
